<template>
  <div class="assetView h-full">
    <el-card class="h-full" :body-style="{ padding: '10px', height: '100%' }">
      <el-row type="flex" :gutter="20" :class="tableLists.length > 0 ? '' : 'h-full'">
        <el-col :span="12" :class="tableLists.length > 0 ? '' : 'h-full'">
          <div class="relative" :style="{ height: tableLists.length > 0 ? '40vh' : '100%' }">
            <el-button size="mini" class="absolute top-5px right-0px z-99" @click="showChangeLog">{{
              $t('changeHistory')
            }}</el-button>
            <el-tabs
              type="border-card"
              class="object-tabs"
              id="baseInfo"
              v-model="activeTab"
              :class="tableLists.length > 0 ? '' : 'h-full'"
            >
              <el-tab-pane
                v-for="(item, index) in tabList"
                :key="index"
                :label="item.name"
                :name="item.name"
              >
                <el-form label-width="130px" v-if="item.flag !== 1 || !isExtend">
                  <el-form-item :label="val.name" v-for="(val, i) in activeData" :key="i">
                    <el-input :value="val.value" readonly>
                      <el-button
                        slot="append"
                        size="small"
                        class="iconfont icon-search"
                        v-if="
                          val.value &&
                            typeof val.value === 'string' &&
                            val.value.indexOf('.') !== -1 &&
                            [...imgExt, ...fileExt, 'pdf'].includes(
                              val.value.substring(val.value.lastIndexOf('.') + 1)
                            )
                        "
                        @click="viewFile(baseAttribute.dynamicData)"
                      ></el-button>
                    </el-input>
                  </el-form-item>
                </el-form>
                <!-- 扩展属性一对多列表 -->
                <div v-else-if="item.flag === 1 && isExtend">
                  <el-table
                    :data="activeData.extendValueList"
                    :highlight-current-row="true"
                    :header-cell-style="{ textAlign: 'center' }"
                    :cell-style="{ textAlign: 'center' }"
                    height="248"
                    row-key="id"
                    stripe
                    border
                  >
                    <el-table-column
                      type="index"
                      width="65"
                      :label="$t('seqNo')"
                      prop="seqNo"
                    ></el-table-column>
                    <el-table-column
                      v-for="(item, index) in activeData.extendTableHeader"
                      :key="index"
                      :label="item.name"
                      :prop="`${item.tableName}.${item.columnName}`"
                      show-overflow-tooltip
                      min-width="150"
                    >
                      <template slot-scope="scope">
                        {{ scope.row[`${item.tableName}.${item.columnName}`] }}
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    class="mt-20px"
                    background
                    @size-change="searchList()"
                    @current-change="getList()"
                    :current-page="activeData.page && activeData.page.pageNo"
                    :page-sizes="$pageSizeAll"
                    :page-size="activeData.page && activeData.page.pageSize"
                    layout="->, total, sizes, prev, pager, next"
                    :total="activeData.page && activeData.page.total"
                  ></el-pagination>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
        <el-col :span="12">
          <div :style="{ height: tableLists.length ? 'calc(40vh - 6px)' : '100%' }">
            <div class="relative-box mb-10px" id="relation">
              <h5 class="flex-row-between">
                <span class="text-14px ml-10px">{{ $t('关联关系') }}</span>
                <i
                  @click="fullScreen('relation')"
                  id="iconFull"
                  v-show="!isFullScreen"
                  class="iconfont icon-line-fullscreen relation-fullScreen cur-pointer position-absolute"
                ></i>
                <i
                  @click="exitFullScreen()"
                  id="iconExitFull"
                  v-show="isFullScreen"
                  class="iconfont icon-line-fullscreen cur-pointer relation-fullScreen position-absolute"
                ></i>
                <el-button
                  type="primary"
                  @click="back"
                  id="backbtn"
                  size="mini"
                  class="float-right"
                  >{{ $t('返回') }}</el-button
                >
              </h5>
              <div id="mynetwork"></div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="table-list" v-if="tableLists.length > 0">
        <el-tabs type="border-card" v-model="currentTabIndex">
          <el-tab-pane
            :label="val.className"
            :name="String(index)"
            v-for="(val, index) in tableLists"
            :key="index"
          >
            <div class="table-search">
              <el-select
                filterable
                style="width: 200px"
                clearable
                class="mr-10px"
                v-model="attrId"
                @change="changeAttr(attrId)"
                :placeholder="$t('code')"
              >
                <el-option
                  v-for="item in codeOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <el-select
                size="small"
                clearable
                filterable
                v-model="symbolValue"
                v-if="selectedAttrType !== 11"
                :placeholder="$t('pleaseSelect')"
                class="mr-10px"
                style="width: 100px"
              >
                <el-option
                  v-for="item in symbolList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                style="width: 200px"
                size="small"
                class="mr-10px"
                v-model.trim="tableParams.keyword"
                :placeholder="$t('请输入关键字')"
                v-if="selectedAttrType === 1"
                clearable
              ></el-input>
              <el-select
                size="small"
                clearable
                v-if="selectedAttrType === 11"
                filterable
                v-model="tableParams.keyword"
                :placeholder="$t('pleaseSelect')"
                class="mr-10px"
                style="width: 200px"
              >
                <el-option
                  v-for="item in labelArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
              <el-input-number
                v-else-if="selectedAttrType === 2 || selectedAttrType === 3"
                v-model.trim="tableParams.keyword"
                :controls="false"
                style="width: 200px; height: 32px"
              ></el-input-number>
              <el-time-picker
                v-else-if="selectedAttrType === 9"
                v-model.trim="tableParams.keyword"
                style="width: 200px; height: 32px"
                :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                value-format="HH:mm:ss"
                :placeholder="$t('PleaseSelectATime')"
              ></el-time-picker>
              <el-date-picker
                v-else-if="selectedAttrType === 8"
                v-model.trim="tableParams.keyword"
                style="width: 200px; height: 32px"
                value-format="yyyy-MM-dd"
                type="date"
                :placeholder="$t('pleaseSelectDate')"
              ></el-date-picker>
              <el-date-picker
                v-else-if="selectedAttrType === 6"
                v-model.trim="tableParams.keyword"
                style="width: 200px; height: 32px"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('SelectADatetime')"
              ></el-date-picker>
              <div class="ml-0px">
                <el-button
                  size="small"
                  class="ml-0px"
                  type="primary"
                  @click="getTabTableData('refresh')"
                  >{{ $t('search') }}</el-button
                >
              </div>
              <!-- <columnVisible
                :options="columnVisibleOptions"
                ref="columnVisible"
                class="dib ml-10px"
                :name="['assetViewColumnVisible']"
                :defaultValue="columnVisible"
                @columnVisibleChanged="changeColumn"
              ></columnVisible> -->
            </div>
            <el-table
              :data="tableDatas"
              border
              v-loading="isLoadTable"
              @sort-change="sortChangeLog"
              @row-dblclick="dbClickOpr"
            >
              <el-table-column
                :prop="key"
                sortable
                :label="headValue"
                v-for="(headValue, key, index) in tableHeader"
                :key="index"
                min-width="150"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="headValue === '版本'">
                    <span
                      class="cursor-pointer text-[#0082ff]"
                      @click="toDetail(scope.row, val.type)"
                      >{{ scope.row[key] }}</span
                    >
                    <span v-for="(item, index) in scope.row.revision" :key="item.id">
                      <span v-if="index < scope.row.revision.length">，</span>
                      <span
                        class="cursor-pointer text-[#0082ff]"
                        @click="toDetail(item, val.type)"
                        >{{ item.revision }}</span
                      >
                    </span>
                  </span>
                  <span v-if="headValue !== '版本' && scope.row[key]">
                    {{ scope.row[key] }}
                    <span v-if="val.unit && scope.row[key]">{{ val.unit }}</span>
                  </span>
                </template>
                <!-- <template slot-scope="scope">
                  <span
                    v-if="
                      computeOperateButton(val.name, '打开文件', '附加在文本') ||
                        computeOperateButton(val.name, '下载文件', '附加在文本')
                    "
                    :class="
                      computeOperateButton(val.name, '打开文件', '附加在文本') ||
                      computeOperateButton(val.name, '下载文件', '附加在文本')
                        ? 'underline cur-pointer'
                        : ''
                    "
                    @click="
                      operateFile(
                        computeOperateButton(val.name, '打开文件', '附加在文本'),
                        computeOperateButton(val.name, '下载文件', '附加在文本'),
                        scope.row,
                        key
                      )
                    "
                    >{{ scope.row[key] }}</span
                  >
                  <span v-else>{{ scope.row[key] }}</span>
                  <el-tooltip
                    content="上传"
                    v-if="computeOperateButton(val.name, '上传文件', '列按钮')"
                  >
                    <el-button
                      class="iconfont icon-export ml-10px"
                      type="success"
                      @click="uploadFile(scope.row, key)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    content="查看"
                    v-if="computeOperateButton(val.name, '打开文件', '列按钮')"
                  >
                    <el-button
                      class="iconfont icon-display ml-10px"
                      type="primary"
                      @click="viewFile(scope.row, key)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    content="下载"
                    v-if="computeOperateButton(val.name, '下载文件', '列按钮')"
                  >
                    <el-button
                      class="iconfont icon-Import ml-10px"
                      type="success"
                      @click="downloadFile(scope.row, key)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    content="删除"
                    v-if="computeOperateButton(val.name, '删除文件', '列按钮')"
                  >
                    <el-button
                      class="iconfont icon-delete ml-10px"
                      type="danger"
                      @click="deleteFile(scope.row, key)"
                    ></el-button>
                  </el-tooltip>
                </template> -->
              </el-table-column>
            </el-table>
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="tableParams.pageNo"
              :page-sizes="[5, 10, 15, 30]"
              :page-size.sync="tableParams.pageSize"
              layout="total, sizes, prev, pager, next"
              :total="pageTotal"
              class="pagination-box"
            ></el-pagination>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
    <!-- 上传start -->
    <el-dialog
      id="viewDialog"
      :width="dialogTitle === '上传' ? '500px' : '1200px'"
      :title="dialogTitle"
      :top="isFullScreen ? '0' : '15vh'"
      :visible.sync="dialogVisible"
      ref="viewDialog"
    >
      <i
        @click="fullScreen('viewDialog')"
        v-if="!isFullScreen && dialogTitle !== '上传'"
        class="iconfont icon-line-fullscreen cur-pointer position-absolute"
      ></i>
      <i
        @click="exitFullScreen()"
        v-if="isFullScreen && dialogTitle !== '上传'"
        class="iconfont icon-line-fullscreen cur-pointer position-absolute"
      ></i>
      <el-upload
        v-if="dialogTitle === '上传'"
        ref="upload"
        drag
        action="https://xx.yy.zz"
        :show-file-list="false"
        :before-upload="getFileContent"
        :http-request="uploadExcel"
        :multiple="false"
        class="flex"
        style="justify-content: center"
      >
        <i style="font-size: 67px" class="el-icon-upload"></i>
        <div class="el-upload__text">
          一次只能上传一个文件，或
          <em>点击上传</em>
        </div>
      </el-upload>
      <div style="height: 600px" id="fileView" v-else v-loading="loadingFile">
        <img :src="viewUrl" class="w-full h-full" v-if="isImg" />
        <iframe v-else :src="viewUrl" class="w-full h-full"></iframe>
      </div>
    </el-dialog>
    <!-- 上传end -->

    <!-- 变更记录 -->
    <changeLogDetail :dialogForm="dialogForm" />
  </div>
</template>

<script>
import vis from 'vis'
import DocumentService from '@/services/DocumentService'
import documentManagementService from '@/services/documentManagement'
import assetService from '@/services/assetService'
import StdAttrBusinessOperation from '@/services/bsApi/StdAttributeBusinessOperation'
// import stdClassDataService from '@/services/bsApi/stdClassDataService'
import StdBusinessOperation from '@/services/bsApi/StdBusinessOperation'
// import ColumnVisible from '@/components/ColumnVisible'
import changeLogDetail from './components/changeLogDetail'

export default {
  components: {
    // ColumnVisible,
    changeLogDetail,
  },
  data() {
    return {
      operators: ['=', '≠', '>', '≥', '<', '<=', 'like', 'nolike'],
      dialogForm: {
        visible: false,
        classId: '',
        dataId: '',
      },
      selectedAttrType: 1,
      symbolList: [
        // { value: '=', name: '等于' },
        // { value: '$ne', name: '不等于' },
        // { value: '$gt', name: '大于' },
        // { value: '$gte', name: '大于等于' },
        // { value: '$lt', name: '小于' },
        // { value: '$lte', name: '小于等于' },
        // { value: '$text', name: '包含' },
        // { value: '$ntext', name: '不包含' },
        // { value: '$in', name: '在范围内' },
        // { value: '$nin', name: '不在范围内' },
      ],
      symbolValue: '',
      attrId: '',
      attrList: [],
      labelArr: [],
      isFullScreen: false,
      currentCode: '',
      currentConfigData: [],
      imgExt: ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'tif'],
      fileExt: ['pptx', 'ppt', 'xlsx', 'xls', 'doc', 'docx', 'txt'], // 转pdf的文件格式
      currentEditType: 'upload',
      viewUrl: '',
      dialogTitle: '上传',
      currentRow: null,
      file: null,
      dialogVisible: false,
      code: '',
      input: '',
      codeOptions: [],
      queryParam: {
        id: this.$route.query.id,
        classId: this.$route.query.classId,
      },
      baseAttribute: {}, // 基本属性数据
      tableDatas: [], // tab切换下面的表格数据对象
      headers: [],
      filterHeaders: [],
      columnVisibleOptions: [],
      columnVisible: [],
      tableLists: [], // tab表格种类集合
      tableParams: {
        pageNo: 1,
        pageSize: 15,
        keyword: '',
      },
      pageTotal: 0,
      currentTabIndex: '', // 当前tab索引
      nodesData: [], // 关联关系节点数据集合
      edgesData: [], // 关联关系边界线数据集合
      isLoadTable: false, // 底部动态表格加载状态
      timer: null,
      currentTabRow: null,
      currentOperateAttrRow: null,
      currentSortParams: {},
      isImg: false, // 是否图片
      browseItem: null, // 浏览文件
      loadingFile: false, // 加载文件
      selectedId: '', // 当前记录id
      tabList: [],
      activeTab: '',
      activeData: [],
      tableHeader: {},
      isSearch: false,
      extendValue: null,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      flag: 0,
      extendTableHeader: [],
      extendValueList: [],
    }
  },
  async created() {
    await this.getSymbolList()
    await this.initDraw(
      this.$route.query.id,
      this.$route.query.classId,
      this.$route.query.currentTreeId
    )
    await this.getBaseAttribute(this.$route.query.id, this.$route.query.classId)
    await this.getTableList(
      this.$route.query.id,
      this.$route.query.classId,
      this.$route.query.currentTreeId
    )
    // await this.getCodeList()
    // await this.getTableData('refresh')
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (!routerBase) {
        return ''
        // eslint-disable-next-line no-else-return
      } else if (routerBase && Array.isArray(routerBase)) {
        return routerBase.length ? `/${routerBase[0]}` : ''
      }
      return `/${routerBase}`
    },
    classId() {
      return this.$route.query.classId || null
    },
    pageType() {
      return this.$route.query.pageType || null
    },
    isExtend() {
      const extendArr = []
      _.forIn(this.baseAttribute, (item) => {
        extendArr.push(...item)
      })
      const isExtendAttribute = _.find(extendArr, { isExtend: 1 })
      return isExtendAttribute || null
    },
    isPrimary() {
      const attributeArr = []
      _.forIn(this.baseAttribute, (item) => {
        attributeArr.push(...item)
      })
      const isPrimaryAttribute = _.find(attributeArr, { isPrimary: true })
      return isPrimaryAttribute || null
    },
    isSplitScreen() {
      const isSplitScreen = _.get(Wiz, 'globalSettings.globalConfig.isSplitScreen')
      return isSplitScreen
    },
  },
  watch: {
    async currentTabIndex(val) {
      this.tableParams = {
        pageNo: 1,
        pageSize: 15,
        keyword: '',
      }
      this.currentEditType = ''
      this.attrId = ''
      this.symbolValue = ''
      this.codeOptions = []
      const currentRow = this.tableLists[_.toNumber(val)]
      this.currentTabRow = currentRow
      if (currentRow) {
        this.getCodeList(currentRow.classId)
        this.getClassRelevancyDataHeader(currentRow.classId, currentRow.whereList, currentRow.type)
        this.getTabTableData('referch')
        this.findAttrConfig(currentRow.classId)
      }
      clearInterval(this.timer)
    },
    dialogVisible(val) {
      if (!val && this.isFullScreen) {
        this.$nextTick(() => {
          this.exitFullScreen()
        })
      }
    },
    attrId(val) {
      if (!val) {
        this.symbolValue = ''
        this.tableParams.keyword = undefined
      } else {
        // this.getTableData('referch')
      }
    },
    activeTab(val) {
      if (val) {
        this.activeData = this.baseAttribute[val]
      }
    },
  },
  mounted() {
    const that = this
    window.onresize = function() {
      if (!that.checkFull()) {
        // 退出全屏后要执行的动作
        that.exitFullScreen()
      }
    }
  },
  methods: {
    // 获取文档详情
    async getDocumentDetail(id, classId) {
      const params = {
        id,
        standardId: localStorage.getItem('standardId'),
      }
      if (classId) {
        params.classId = classId
        params.isversion = true
      }
      const docBasicAttrRes = await DocumentService.findDocAttr(params)
      if (docBasicAttrRes && docBasicAttrRes.code === 0 && docBasicAttrRes.data) {
        if (docBasicAttrRes.data.defaultFileId?.includes('http')) {
          window.open(docBasicAttrRes.data.defaultFileId)
          return
        }
        if (this.isSplitScreen && window.wiz) {
          const fileRes = await DocumentService.getDocumentFileType({
            fileId: docBasicAttrRes.data.defaultFileId,
            standardId: localStorage.getItem('standardId'),
            isVersion: false,
          })
          if (fileRes && fileRes.code === 0 && fileRes.data) {
            const fileNameType = _.split(fileRes.data.fileName, '.')
            let fileType = _.last(fileNameType)
            const url = `${
              Wiz.GetModuleConfig('legacy-resource').currentEnv.VUE_APP_STANDARD_SERVER
            }/api/std/file/${fileRes.data.fileId}`
            const tagInfo = _.find(this.baseAttribute['对象'], ['code', 'Code'])
            if (fileType === 'pr' || fileType === 'pprj') {
              fileType = '3d'
            }
            if (!['3d', 'svg', 'pdf'].includes(fileType)) {
              window.open(url)
              return
            }
            window.wiz.OpenFileView(
              fileRes.data.fileName,
              url,
              fileType,
              docBasicAttrRes.data.defaultFileId,
              fileRes.data.documentId,
              fileRes.data.standardId,
              'page',
              tagInfo.value
            )
          }
        } else {
          const query = {
            documentId: id,
            title: encodeURIComponent(docBasicAttrRes.data.name),
            standardId: localStorage.getItem('standardId'),
            classId: docBasicAttrRes.data.classId,
            defaultFileId: docBasicAttrRes.data.defaultFileId,
          }
          if (classId) query.isVersion = '1'
          this.$router.push({
            path: `${this.basePath}/legacy-resource/data-collection-manage/doc-view`,
            query,
          })
        }
      }
    },
    showChangeLog() {
      this.dialogForm.visible = true
      this.dialogForm.classId = this.$route.query.classId
      this.dialogForm.dataId = this.$route.query.id
    },
    // 查看详情页面
    async toDetail(row, type) {
      if (type === 8) {
        // 关联文档
        this.getDocumentDetail(row.id, row.classId || '')
      } else if (_.includes([0, 1, 4, 5], type)) {
        if (!row.class_id || row.class_id === '' || row.class_id === null) {
          this.$message.warning('没有实体类别')
          return
        }
        await this.initDraw(row.id, row.class_id)
        await this.getBaseAttribute(row.id, row.class_id)
        await this.getTableList(row.id, row.class_id)
      } else if (_.includes([2, 3, 6, 7], type)) {
        const obj = this.tableLists[Number(this.currentTabIndex)]
        await this.initDraw(row.id, obj.classId)
        await this.getBaseAttribute(row.id, obj.classId)
        await this.getTableList(row.id, obj.classId)
      }
    },
    handleSizeChange(size) {
      this.tableParams.pageSize = size
      if (this.isSearch) {
        this.getTableData('referch')
      } else {
        this.getTabTableData('referch')
      }
    },
    handleCurrentChange(num) {
      this.tableParams.pageNo = num
      if (this.isSearch) {
        this.getTableData('referch')
      } else {
        this.getTabTableData('refrech')
      }
    },
    // 切换tab获取表格数据
    async getTabTableData(type) {
      if (type === 'referch') {
        this.tableParams.pageNo = 1
      }
      this.isSearch = false
      this.isLoadTable = true
      const whereList = []
      if (this.attrId && this.symbolValue !== '' && this.tableParams.keyword) {
        if (this.currentTabRow.whereList.length > 0) {
          whereList.push('&&')
        }
        const currentClass = _.find(this.codeOptions, { id: this.attrId })
        const currentCode = `${this.currentTableName}.${currentClass.colName}`
        whereList.push(currentCode)
        if (this.operators[this.symbolValue] === 'nolike') {
          whereList.push('not')
          whereList.push('like')
        } else {
          whereList.push(this.operators[this.symbolValue])
        }

        if (['like', 'nolike'].includes(this.operators[this.symbolValue])) {
          whereList.push(`{string}:%${this.tableParams.keyword}%`)
        } else {
          whereList.push(`{string}:${this.tableParams.keyword}`)
        }
      }
      console.log(this.codeOptions, 'codeOptions123')
      console.log(
        this.currentTabRow.whereList,
        this.attrId,
        this.symbolValue,
        '1122',
        this.tableParams.keyword
      )
      const res = await assetService.getClassRelevancyData({
        dataId: this.$route.query.id,
        classId: this.currentTabRow.classId,
        whereList: [...this.currentTabRow.whereList, ...whereList],
        documentIds: this.currentTabRow.documentIds,
        maxResultCount: this.tableParams.pageSize,
        skipCount: (this.tableParams.pageNo - 1) * this.tableParams.pageSize,
        type: this.currentTabRow.type,
      })
      this.isLoadTable = false
      if (res && res.code === 0 && res.data) {
        this.tableDatas = res.data
        this.pageTotal = res.totalCount
      }
    },
    // 获取操作符
    async getSymbolList() {
      this.symbolList = []
      const res = await assetService.getSearchOperator()
      if (res && res.code === 0 && res.data) {
        _.map(res.data, (item) => {
          this.symbolList.push({
            label: item.text,
            value: item.value,
          })
        })
        if (this.symbolList.length) {
          this.symbolValue = this.symbolList[0].value
        }
      }
    },
    textType(type) {
      let text = ''
      switch (type) {
        case 0:
        case 2:
          text = '父'
          break
        case 1:
        case 3:
          text = '子'
          break
        case 8:
          text = '关联文档'
          break
        default:
          text = ''
          break
      }
      return text
    },
    sortChangeLog(row) {
      let orderbytype = ''
      switch (row.order) {
        case 'ascending':
          orderbytype = 0
          break
        case 'descending':
          orderbytype = 1
          break
        default:
          orderbytype = ''
          break
      }
      this.currentSortParams = {
        orderby: row.prop,
        orderbytype,
      }
      this.getTableData()
    },
    changeColumn(data) {
      if (data.length === 0 && this.filterHeaders.length === 1) {
        this.$message({
          type: 'warning',
          message: this.$t('pleaseSelectAtLeaseOneTableHeader'),
        })
        return
      }
      this.columnVisible = data
      this.filterHeaders = _.filter(this.headers, (item) => {
        return _.includes(data, item.code)
      })
      this.$nextTick(() => {
        if (this.$refs.table) {
          this.$refs.table.doLayout()
        }
      })
    },
    async changeAttr(value) {
      if (!value) {
        return
      }
      this.tableParams.keyword = undefined
      // this.codeOptions.forEach((item) => {
      //   if (item.columnName === value) {
      //     this.selectedAttrType = item.valueType
      //   }
      // })
      // if (this.selectedAttrType === 11) {
      //   const parameter = {
      //     classId: this.classId,
      //   }
      //   const res = await stdClassDataService.getTagAttrList(parameter)
      //   if (res && res.code === 0 && res.data) {
      //     this.labelArr = res.data
      //   }
      // }
    },
    checkFull() {
      // 判断浏览器是否处于全屏状态 (需要考虑兼容问题)
      // 火狐浏览器
      let isFull =
        document.mozFullScreen ||
        document.fullScreen ||
        // 谷歌浏览器及Webkit内核浏览器
        document.webkitIsFullScreen ||
        document.webkitRequestFullScreen ||
        document.mozRequestFullScreen ||
        document.msFullscreenEnabled
      if (isFull === undefined) {
        isFull = false
      }
      return isFull
    },
    fullScreen(dom) {
      this.isFullScreen = true
      this.launchFullscreen(document.getElementById(dom))
      document.getElementById('backbtn').style.display = 'none'
      $('.relative-box').css('background-color', '#fff')
      if (dom === 'baseInfo') {
        $('.el-tabs__content').css('height', '100vh')
      }
      document.getElementById('iconExitFull').style.right = '20px'
    },

    exitFullScreen() {
      this.isFullScreen = false
      document.getElementById('backbtn').style.display = 'block'
      this.exitFullscreen()
      $('.el-dialog')
        .width(1200)
        .height(600)
      $('#fileView').height(515)
      $('.el-tabs__content').css('height', '35vh')
    },
    // 判断各种浏览器，找到正确的方法
    launchFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
      $('.el-dialog')
        .width(window.screen.width)
        .height(window.screen.height)
      $('#fileView').height(window.screen.height - 100)
    },
    // 判断浏览器种类
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
    computeOperateButton(columnName, operateName, btnType) {
      // 查看和下载可以附加在文本也可以列按钮，上传只能列按钮
      let showBtn = false
      _.forEach(this.currentConfigData, (item) => {
        if (
          item.attributeName === columnName &&
          item.businessOperationName === operateName &&
          item.presentationTypeStr === btnType
        ) {
          showBtn = true
          return false
        }
      })
      return showBtn
    },
    operateFile(viewFile, downloadFile, row, code) {
      // 点击附加在文本
      if (viewFile) {
        // 查看
        this.viewFile(row)
        return
      }
      if (downloadFile) {
        // 下载
        this.downloadFile(row, code)
      }
    },
    async uploadExcel() {
      const formData = new FormData()
      _.forIn({ file: this.file }, (value, key) => {
        formData.append(key, value)
      })
      const fileType = _.split(this.file.name, '.')[1]
      if (_.includes(this.fileExt, fileType) && fileType !== 'pdf') {
        formData.append('type', 1)
      } else {
        formData.append('type', 0)
      }
      const res = await assetService.uploadFile({
        reqData: formData,
      })
      if (res && res.code === 0 && res.data) {
        this.$message.success(this.$t('UploadedSuccessfully'))
        this.saveFile(res.data[0].source)
        this.dialogVisible = false
      }
    },
    async saveFile(source) {
      const res = await assetService.updateAttrData({
        dataId: this.currentRow.id,
        attributeList: [
          {
            value: source,
            classId: this.currentTabRow.classId,
            columnName: this.currentCode,
          },
        ],
      })
      if (res && res.code === 0) {
        // 上传成功刷新列表
        this.getCodeList(this.currentTabRow.classId)
      }
    },
    getFileContent(file) {
      this.file = file
    },
    uploadFile(row, code) {
      this.currentCode = code
      this.dialogTitle = '上传'
      this.currentRow = row
      this.dialogVisible = true
      $('.el-dialog')
        .width(600)
        .height(300)
    },
    deleteFile(row, code) {
      if (!row[code]) {
        this.$message.warning('未上传文件')
        return
      }
      this.currentCode = code
      this.currentRow = row
      this.$confirm(this.$t('confirmToDeleteForever'), this.$t('confirm'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      }).then(() => {
        this.saveFile('')
      })
    },
    async downloadFile(row, columnName) {
      const res = await assetService.findAttrData({
        classId: this.currentTabRow.classId,
        dataId: row.id,
        columnName,
      })
      if (res && res.code === 0 && res.data) {
        const currentRow = _.find(res.data.attributeList, ['columnName', columnName])
        if (![...this.imgExt, ...this.fileExt, 'pdf'].includes(_.split(currentRow.value, '.')[1])) {
          this.$message.warning('未上传文件')
          return
        }
        const url = `${currentEnv.VUE_APP_UPLOAD_SERVER}/api/Common/file?downloadType=1&target=${
          _.split(currentRow.value, '.')[0]
        }&type=0`
        window.location.href = url
      }
    },
    viewBasicFile(fileName) {
      this.dialogTitle = this.$t('view')
      if (this.imgExt.includes(_.split(fileName, '.')[1]) || fileName.includes('pdf')) {
        this.viewUrl = `${currentEnv.VUE_APP_UPLOAD_SERVER}/api/Common/file?downloadType=0&type=0&target=${fileName}`
      } else {
        this.viewUrl = `${
          currentEnv.VUE_APP_UPLOAD_SERVER
        }/api/Common/file?downloadType=0&type=1&target=${_.split(fileName, '.')[0]}`
      }
      this.dialogVisible = true
    },
    async getFileId(id) {
      // 1.先通过当前记录的id拿到fileId
      const res = await assetService.getFileId({ ownerId: this.selectedId, stepId: id })
      if (res.length > 0) {
        this.browseItem = res[res.length - 1]
      } else {
        this.browseItem = null
      }
    },
    async viewFile(row) {
      this.selectedId = row.id // 当前记录id
      await this.getFileId(row.stdClassAttributeId)
      this.dialogTitle = this.$t('view')
      $('.el-dialog')
        .width(1200)
        .height(700)
      if (this.browseItem !== null) {
        this.loadingFile = true
        this.dialogVisible = true
        if (_.includes(this.imgExt, this.browseItem.fileType.split('.')[1])) {
          // png
          this.isImg = true
          const resData = await assetService.browsePNG({ fileId: this.browseItem.fileId })
          if (resData) {
            const blob = new Blob([resData], { type: 'image/jpeg' })
            const url = window.URL.createObjectURL(blob)
            this.viewUrl = url
            this.loadingFile = false
          }
        } else {
          // pdf
          this.isImg = false
          const resData = await assetService.browsePDF({ fileId: this.browseItem.fileId })
          if (resData) {
            const blob = new Blob([resData], { type: 'application/pdf' })
            const url = window.URL.createObjectURL(blob)
            this.viewUrl = url
            this.loadingFile = false
          }
        }
      } else {
        this.$message.warning('未上传文件')
      }
    },
    async findOperateType(name, item) {
      // 获取操作类型
      const res = await StdBusinessOperation.find({
        name: {
          $text: name,
        },
      })
      if (res && res.code === 0 && res.data) {
        switch (res.data[0].responder) {
          // 通过responder判断操作类型
          case 'GetRealData': // 获取实时数据
            this.timer = setInterval(() => {
              if (item.parameterList[0].parameterType === 0) {
                // 固定值
                this.findRealTimeData(0, item.parameterList[0].fixedValue, item.attributeName)
              } else {
                // 选择属性
                this.findRealTimeData(1, item.parameterList[0].attributeName, item.attributeName)
              }
            }, 5000)
            break
          case 'xxx/openfile': // 打开文件
            this.currentOperateAttrRow = item.parameterList[0]
            this.currentEditType = 'view'
            break
          case 'xxx/uploadfile': // 上传文件
            this.currentOperateAttrRow = item.parameterList[0]
            this.currentEditType = 'upload'
            break
          default:
            // 下载文件
            this.currentOperateAttrRow = item.parameterList[0]
            this.currentEditType = 'download'
            break
        }
      }
    },
    async findAttrConfig(classId) {
      const res = await StdAttrBusinessOperation.find({
        pageNo: 1,
        pageSize: 999,
        class_id: classId,
      })
      if (res && res.code === 0 && res.data) {
        this.currentConfigData = res.data
        _.forEach(res.data, (item) => {
          this.findOperateType(item.businessOperationName, item)
        })
      }
    },
    async findRealTimeData(type, chooseAttrName, attrName) {
      let attrCode
      if (type === 1) {
        // 选择属性
        attrCode = _.find(this.tableDatas.headers, ['name', chooseAttrName])
      }
      const unitCode = _.find(this.tableDatas.headers, ['name', attrName])
      const codes =
        type === 0
          ? chooseAttrName
          : _.map(this.tableDatas.dynamicData, (item) => {
              return item[attrCode.code]
            }).join(',')
      if (_.isEmpty(codes)) {
        clearInterval(this.timer)
        return
      }
      const res = await assetService.getWizData({
        pointIds: '',
        codes:
          type === 0
            ? chooseAttrName
            : _.map(this.tableDatas.dynamicData, (item) => {
                return item[attrCode.code]
              }).join(','),
      })
      if (res && res.code === 0 && res.data) {
        _.forEach(this.tableDatas.dynamicData, (item) => {
          const currentRow = _.find(res.data, ['code', item[attrCode.code]])
          this.$set(item, unitCode.code, currentRow.value)
        })
      }
    },
    async dbClickOpr() {
      // const obj = this.tableLists[Number(this.currentTabIndex)]
      // const res = await assetService.addClassRelation({
      //   classid: obj.classId,
      //   id: val.id,
      //   joinclassid: obj.joinClassId,
      //   dataid: obj.dataId,
      //   referencetype: obj.referenceType,
      // })
      // if (res && res.code === 0 && res.data) {
      //   // 去重
      //   let flag = false
      //   _.forEach(this.nodesData, (item) => {
      //     if (item.id === res.data.objNodes[0].id) {
      //       flag = true
      //     }
      //   })
      //   if (!flag) {
      //     this.nodesData.push(res.data.objNodes[0])
      //     this.edgesData.push(res.data.edges[0])
      //     this.initSetting()
      //   }
      // }
    },
    // 获取代码下拉集合
    async getCodeList(classId) {
      if (!this.tableLists.length) {
        return
      }
      const parameter = {
        classId,
        maxResultCount: 999,
        nameOrCode: '',
        skipCount: 0,
        sorting: '',
      }
      const res = await assetService.getClassAndClassTypeAttrDropDowData(parameter)
      if (res && res.code === 0 && res.data) {
        this.codeOptions = res.data
        if (this.codeOptions.length) {
          this.attrId = this.codeOptions[0].id
          // this.selectedAttrType = this.codeOptions[0].valueType
        }
        // this.getTableData('refresh')
      }
    },
    // 获取基本属性(属性分组)
    async getBaseAttribute(dataId, classOrTypeId) {
      if (!dataId || !classOrTypeId) {
        return
      }
      const res = await assetService.getClassAndClassTypeDynamicData({
        dataId,
        classOrTypeId,
      })
      if (res && res.code === 0) {
        this.baseAttribute = res.data
        this.tabList = Object.keys(res.data).map((item) => {
          return { name: item }
        })
        this.activeTab = this.tabList[0].name
        this.activeData = this.baseAttribute[this.activeTab]
        if (this.isExtend && this.isExtend.value) {
          await this.getExtensionList()
          await this.getExtendDataList()
        }
      }
    },
    // 获取扩展属性下拉数据(多属性)
    async getExtensionList() {
      const res = await documentManagementService.getExtendClassList({
        classId: this.isExtend.classId,
      })
      if (res && res.code === 0) {
        this.extendValue = res.data.filter((item) => {
          if (this.isExtend.value.split(',').includes(item.extendClassCode)) {
            this.tabList.push({ name: item.extendClassName })
            return item
          }
          return null
        })
      }
    },
    // 获取扩展属性数据
    async getExtendDataList() {
      this.extendValue.forEach(async (it) => {
        const params = {
          maxResultCount: this.page.pageSize,
          skipCount: this.page.pageSize * (this.page.pageNo - 1),
          attributeId: it.classAttributeId,
          attributeData: it.extendClassCode,
          data: this.isPrimary.value,
        }
        const res = await documentManagementService.getExtendData(params)
        if (res && res.code === 0) {
          this.tabList.map((k) => {
            if (k.name === it.extendClassName) {
              k.flag = res.data.flag
            }
            return k
          })
          if (res.data.flag === 0) {
            if (!res.data.data.data) return
            const val = res.data.data.data[0]
            Object.keys(val).forEach((item) => {
              res.data.attributeDataModels.forEach((el) => {
                if (`${el.tableName}.${el.columnName}` === item) {
                  el.value = val[item]
                }
              })
            })
            this.baseAttribute[it.extendClassName] = res.data.attributeDataModels
          } else {
            this.baseAttribute[it.extendClassName] = {
              page: {
                pageNo: 1,
                pageSize: 15,
                total: 0,
              },
            }
            const temp = this.baseAttribute[it.extendClassName]
            temp.extendTableHeader = res.data.attributeDataModels || []
            temp.extendValueList = res.data.data.data || []
            temp.page.total = res.data.data.totalCount
          }
        }
      })
    },
    // 获取table表格种类集合
    async getTableList(dataId, classId, structureBreakdownId) {
      if (!dataId || !classId) {
        return
      }
      // this.queryParam.breakdownid = this.$route.query.currentTreeId
      const res = await assetService.getClassRelevancyDataClassList({
        dataId,
        classId,
        structureBreakdownId,
      })
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.tableLists = _.map(res.data, (item) => {
          if (item.type) {
            if (item.type === 8) {
              item.className = '关联文档'
            } else {
              const text = this.textType(item.type)
              item.className = text ? `${item.className}(${text})` : item.className
            }
          }
          return item
        })
        this.currentTabRow = this.tableLists[0]
        this.getCodeList(this.currentTabRow.classId)
        this.findAttrConfig(this.currentTabRow.classId)
        this.getClassRelevancyDataHeader(
          this.currentTabRow.classId,
          this.currentTabRow.whereList,
          this.currentTabRow.type
        )
        this.getTabTableData('referch')
        $('.el-tabs__content').css('height', '35vh')
      } else {
        this.tableLists = []
        this.currentTabRow = {}
        $('.el-tabs__content').css('height', 'calc(100% - 40px)')
      }
    },
    // 获取实体关联数据表头
    async getClassRelevancyDataHeader(classId, whereList, type) {
      if (!classId) return
      this.currentTableName = ''
      const res = await assetService.getClassRelevancyDataHeader({
        dataId: this.$route.query.id,
        classId,
        whereList,
        maxResultCount: 999,
        skipCount: 0,
        type,
      })
      if (res && res.code === 0 && res.data) {
        this.tableHeader = res.data
        _.forIn(res.data, (value, key) => {
          if (!this.currentTableName) {
            this.currentTableName = key.split('.')[0]
          }
        })
      }
    },
    // 获取动态关联表数据
    async getTableData(type) {
      if (!this.tableLists.length) {
        return
      }
      if (!this.attrId && type === 'refresh') {
        this.$message.warning('请先选择代码')
        return
      }
      if (this.symbolValue === '' || this.symbolValue === null) {
        this.$message.warning('请先选择操作符')
        return
      }
      if (type === 'refresh') {
        this.tableParams.pageNo = 1
      }
      // 当属性类行为标签类型（11），需要额外的参数
      // if (this.selectedAttrType !== 11 && (this.symbolValue === '=' || this.symbolValue === ''))
      // {
      //   this.tableParams[this.attrId] = this.tableParams.keyword
      // } else if (
      //   this.selectedAttrType !== 11 &&
      //   (this.symbolValue !== '=' || this.symbolValue !== '')
      // ) {
      //   const obj = {}
      //   obj[this.symbolValue] = this.tableParams.keyword
      //   this.tableParams[this.attrId] = obj
      // } else {
      //   this.tableParams.tagcolumn = this.attrId
      //   this.tableParams.tagvalue = `${this.tableParams.keyword},`
      // }
      // let params = _.assign({}, this.tableParams, this.tableLists[Number(this.currentTabIndex)])
      // if (!_.isNil(this.currentSortParams)) {
      //   params = _.assign(params, this.currentSortParams)
      // }
      this.isSearch = true
      this.isLoadTable = true
      const res = await assetService.searchClassRelevancyData({
        maxResultCount: this.tableParams.pageSize,
        skipCount: (this.tableParams.pageNo - 1) * this.tableParams.pageSize,
        sorting: '',
        classAttributeId: this.attrId,
        operator: this.symbolValue,
        keywords: this.tableParams.keyword,
      })
      this.isLoadTable = false
      if (res && res.code === 0 && res.data) {
        this.tableDatas = res.data
        // this.headers = this.tableDatas.headers
        // this.headers.forEach((item) => {
        //   this.$set(item, 'label', item.name)
        //   this.$set(item, 'value', item.code)
        // })
        // this.columnVisible = this.headers.map((item) => {
        //   return item.code
        // })
        // this.columnVisibleOptions = this.headers
        // if (this.$refs.columnVisible) {
        //   this.$refs.columnVisible.columnVisible = this.columnVisible
        // }
        // this.changeColumn(this.columnVisible)
        this.pageTotal = res.totalCount
      }
    },
    // 初始化关联关系图
    initDraw(dataId, classId, structureBreakdownId) {
      if (!dataId || !classId) {
        return
      }
      this.$nextTick(async () => {
        const resNodes = await assetService.getRelationData({
          dataId,
          classId,
          structureBreakdownId,
        })
        if (resNodes && resNodes.code === 0 && resNodes.data) {
          this.nodesData = resNodes.data.objNodes
          this.edgesData = resNodes.data.edges
        }
        this.initSetting()
      })
    },
    // 初始化关系图的配置
    initSetting() {
      const nodes = new vis.DataSet(this.nodesData)
      const edges = new vis.DataSet(this.edgesData)
      const container = document.getElementById('mynetwork')
      const data = { nodes, edges }

      const options = {
        autoResize: true,
        height: '100%',
        width: '100%',
        nodes: {
          shape: 'circle',
          size: 60,
          font: {
            color: 'white',
            size: 12,
            align: 'center',
            multi: true,
            bold: true,
          },
          borderWidth: 1,
          borderWidthSelected: 3,
          color: {
            border: '#2B7Ca9',
            background: '#2B7CE9',
            highlight: { background: '#2B7CE9' },
          },
        },
        edges: {
          font: { size: 12 },
          width: 2,
          length: 150,
          smooth: { enabled: false },
          arrows: { to: true },
        },
        physics: {
          enabled: true,
          stabilization: {
            enabled: true,
            iterations: 50,
            fit: true,
          },
          barnesHut: {
            gravitationalConstant: -2000,
            centralGravity: 0.1,
            springLength: 150,
            springConstant: 0.04,
            damping: 0.09,
            avoidOverlap: 0,
          },
        },
      }

      const network = new vis.Network(container, data, options)
      this.network = network

      // 找到中心节点并固定位置
      const centerNode = this.nodesData.find((node) => {
        return node.level === 0 || node.root === true
      })
      if (centerNode) {
        nodes.update({
          id: centerNode.id,
          fixed: true,
        })
      }

      // 监听稳定化完成事件
      network.once('stabilizationEnd', () => {
        // 获取容器尺寸
        const containerWidth = container.offsetWidth
        const containerHeight = container.offsetHeight
        const centerX = containerWidth / 2
        const centerY = containerHeight / 2

        // 获取当前视图位置和比例
        const scale = network.getScale()
        const viewPosition = network.getViewPosition()

        // 计算偏移量
        const offsetX = centerX - viewPosition.x
        const offsetY = centerY - viewPosition.y

        // 移动到容器中心
        network.moveTo({
          position: { x: centerX, y: centerY },
          scale,
          offset: { x: offsetX, y: offsetY },
          animation: {
            duration: 1000,
            easingFunction: 'easeInOutQuad',
          },
        })

        // 禁用物理引擎以防止进一步移动
        network.setOptions({ physics: { enabled: false } })
      })

      // 监听布局变化
      network.on('startStabilizing', () => {
        network.fit()
      })

      // 处理节点选择
      network.on('selectNode', async (clickData) => {
        const currentNode = data.nodes.get(clickData.nodes[0])
        if (currentNode.type === 2) {
          // this.getDocumentDetail(currentNode.documentId)
        } else {
          this.currentTabIndex = '0'
          const arr = clickData.nodes[0].split(',')
          await this.getBaseAttribute(arr[0], arr[1])
          await this.getTableList(arr[0], arr[1])
          await this.initDraw(arr[0], arr[1])
        }
      })

      // 监听容器大小变化
      const resizeObserver = new ResizeObserver(() => {
        if (this.network) {
          this.network.fit({
            animation: {
              duration: 1000,
              easingFunction: 'easeInOutQuad',
            },
          })
        }
      })
      resizeObserver.observe(container)

      // 组件销毁时清理
      this.$once('hook:beforeDestroy', () => {
        resizeObserver.disconnect()
      })
    },
    // 返回操作
    back() {
      if (this.pageType === 'assetView') {
        this.$router.push({
          path: './asset-catalogue',
          query: {
            currentTreeId: this.$route.query.currentTreeId,
            currentTreeName: this.$route.query.currentTreeName,
          },
        })
      } else if (this.pageType === 'masterData') {
        this.$router.push({
          path: `${this.basePath}/legacy-resource/master-data-management/data-list`,
          query: {
            currentTreeId: this.$route.query.currentTreeId,
            currentTreeName: this.$route.query.currentTreeName,
          },
        })
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style lang="scss" scoped type="text/scss">

@import '~vis/dist/vis.css';
/deep/.vis-tooltip {
  width: 300px !important;
  white-space: pre-wrap !important;
}
.icon-line-fullscreen {
  top: 23px;
  right: 45px;
}
.position-absolute {
  position: absolute;
}
.relation-fullScreen {
  top: 0px;
  right: 80px;
}
.relative-box {
  border: 1px solid lightgray;
  height: 100%;
  h5 {
    background-color: rgba(177, 176, 176, 0.151);
    height: 35px;
    line-height: 35px;
  }
  #mynetwork {
    width: 100%;
    height: 90%;
  }
}
.table-list {
  height: calc(100% - 40vh);
  position: relative;
  /deep/.el-input__suffix-inner {
    display: inline-block;
    margin-top: -4px;
  }
  /deep/.el-tabs__nav-next,
  /deep/.el-tabs__nav-prev {
    line-height: 34px !important;
    font-size: 20px;
    color: #1682e6;
  }
  /deep/.el-tabs__content {
    height: calc(60vh - 198px) !important;
    position: relative;
    .el-table__body-wrapper {
      height: calc(60vh - 365px) !important;
      overflow-y: auto !important;
    }
    .pagination-box {
      position: absolute;
      bottom: 10px;
      right: 10px;
    }
  }
  .table-search {
    height: 30px;
    display: flex;
    width: 100%;
    flex-direction: row;
    margin-bottom: 20px;
    /deep/.el-input__inner {
      height: 30px;
    }
    /deep/.el-input__suffix {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.object-tabs {
  /deep/.el-tabs__content {
    height: 35vh;
    overflow-y: auto;
    .el-form-item__label {
      text-align: right;
    }
  }
  /deep/.el-form-item__content {
    margin-left: 140px !important;
  }
}
.el-tabs--border-card {
  background: #ffffff !important;
}
/deep/.el-input__inner {
  height: 32px !important;
}
/deep/.el-input__icon {
  line-height: 32px;
}
.underline {
  text-decoration: underline;
}
.object-tabs /deep/.el-tabs__header {
  width: calc(100% - 78px);
}
.el-tabs--border-card {
  box-shadow: none !important;
}

</style>
